module.exports = __webpack_public_path__ + "img/20190604161502QQ截图20190603170410.3b6b4ba9.png";